import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'vl-token',
  standalone: true,
  imports: [
    MatIconModule
  ],
  templateUrl: './token.component.html',
  styleUrl: './token.component.scss'
})
export class TokenComponent {

  public token: string = "";

  constructor(
    private userService: UserService,
  ) {
    this.token = this.userService.getToken();
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.token);
  }

}
